import React, { PureComponent } from 'react'
import { Button, Modal, Col, Tooltip, OverlayTrigger, Glyphicon } from 'react-bootstrap'
import InputText from '../../commons/form/InputText'
import InputSelect from '../../commons/form/InputSelect'
import InputTreeSelect from '../../commons/form/InputTreeSelect'
import { reduxForm, Field } from 'redux-form'
import { isEmail, isValidPhone } from '../../../util/validationFunctions'
import InputPassword from '../../commons/form/InputPassword'
import InputCheckBox from '../../commons/form/InputCheckBox'
import { permissions } from '../../../constants/backendIds'
import { getSectionPermissions } from '../../../util/permisionFunctions'
import { sectionPermissions } from '../../../constants/dossier/common/buttonsHeader'
import UploadSignPage from '../../../containers/masters/user/UploadModalPage'
import { handleKeyDown } from '../../../util/utils'

class UserModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      editing: false,
      editingUO: false,
      selectedRole: null,
      selectedUo: null,
      roleList: [],
      uoList: [],
      uoListSalesman: [],
      showChangePassword: false,
      newPassword: null,
      repeatNewPassword: null,
      isOldUser: true,
      uoSalesman: [],
      UOsCanDelete: true
    }

    this.setActiveUoRol = this.setActiveUoRol.bind(this)
    this.setActiveUo = this.setActiveUo.bind(this)
    this.deletePermission = this.deletePermission.bind(this)
  }

  componentDidMount () {
    this.initializePermisions(this.props)
    this.props.actions.fetchPasswordPolicy()
    this.props.actions.fetchLanguagesCombo()
  }

  getSnapshotBeforeUpdate (prevProps) {
    this.setState({ isOldUser: this.props.userId !== null && this.props.userId !== undefined })
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.setState({ uoList: this.props.uoRoles, editing: false, selectedRole: null, selectedUo: null, uoSalesman: this.props.uoSalesman ? this.props.uoSalesman : { notOwnedUO: [], ownedUO: [] } })
      this.props.change('userRol.organizedUnit', null)
      this.props.change('userRol.role', null)
      this.props.change('userUO.organizedUnit', null)
    }
    return null
  }

  componentDidUpdate () {
    // getSnapshotBeforeUpdate() should be used with componentDidUpdate()
  }

  initializePermisions (props) {
    const section = props.sections.filter((tabConf) => tabConf.code === sectionPermissions.admin)
    if (section.length > 0 && section[0] != null) {
      const newState = getSectionPermissions(section[0])
      this.setState({ sectionTabsConfiguration: newState })
    }
  }

  setActiveUoRol (organizedUnitId) {
    if (organizedUnitId) {
      const uo = this.state.uoList.find(uoRol => uoRol.organizedUnitId === parseInt(organizedUnitId))
      this.setState({ roleList: uo && uo.notOwnedRoles ? uo.notOwnedRoles : [], selectedUo: organizedUnitId })
    } else {
      this.setState({ selectedUo: null })
    }
  }

  deleteRecoverSalesman (uo) {
    const uoSalesman = this.state.uoSalesman
    let uoToUpdate = uoSalesman.ownedUO.find(ownedUo => ownedUo.salesmanId === uo.salesmanId && ownedUo.uoId === uo.uoId)
    uoToUpdate.isDeleteSalesman = !uoToUpdate.isDeleteSalesman
    if (uoToUpdate.isDeleteSalesman) {
      this.props.actions.deleteSalesman(uoToUpdate.userId, uoToUpdate.salesmanId)
    } else {
      this.props.actions.recoverSalesman(uoToUpdate.userId, uoToUpdate.salesmanId)
    }
    this.setState({ uoSalesman })
  }

  setActiveUo (organizedUnitId) {
    if (organizedUnitId) {
      const UO = this.state.uoListSalesman.find(UOs => UOs.organizedUnitId === parseInt(organizedUnitId))
      this.setState({ uoListSalesman: UO && UO.notOwnedUO ? UO.notOwnedUO : [], selectedUo: organizedUnitId })
    } else {
      this.setState({ selectedUo: null })
    }
  }

  addUO (newUO) {
    const uoSalesman = this.state.uoSalesman
    const isAssigned = uoSalesman.ownedUO.find(val => val.uoId === newUO)
    if (!isAssigned) {
      const uoSalesmanCons = uoSalesman.notOwnedUO.find((val) => val.uoId === newUO)
      uoSalesman.notOwnedUO = uoSalesman.notOwnedUO.filter(val => val.uoId !== newUO)
      uoSalesman.ownedUO.push(uoSalesmanCons)
      this.setState({ uoSalesman })
    }
    this.setState({ editingUO: false })
  }

  deleteUO (oldUO) {
    let uoSalesman = Object.assign([], uoSalesman, this.state.uoSalesman)
    const uoSalesmanCons = uoSalesman.ownedUO.find((val) => val.uoId === oldUO)
    if (uoSalesmanCons) {
      uoSalesman.ownedUO = uoSalesman.ownedUO.filter(val => val.uoId !== oldUO)
      uoSalesman.notOwnedUO.push(uoSalesmanCons)
      this.setState({ uoSalesman })
    }
  }

  addPermission (newRole) {
    const uoRoles = this.state.uoList
    const uo = uoRoles.find(val => val.organizedUnitId === this.state.selectedUo)
    const isAssigned = uo.ownedRoles.find((val) => val.roleId === newRole)
    if (!isAssigned) {
      const role = uo.notOwnedRoles.find((val) => val.roleId === newRole)
      uo.notOwnedRoles = uo.notOwnedRoles.filter(val => val.roleId !== newRole)
      uo.ownedRoles.push(role)
      this.setState({ uoList: uoRoles, roleList: uo.notOwnedRoles })
      this.setState({ LastAdd: false })
      this.props.change('userRol.role', null)
    }
    this.setState({ editing: false })
  }

  deletePermission (oldRole, organizedUnitId) {
    let uoRoles = Object.assign([], uoRoles, this.state.uoList)
    const uo = uoRoles.find(val => val.organizedUnitId === organizedUnitId)
    const role = uo.ownedRoles.find((val) => val.roleId === oldRole)
    if (role) {
      uo.ownedRoles = uo.ownedRoles.filter(val => val.roleId !== oldRole)
      uo.notOwnedRoles.push(role)
      this.setState({ uoList: uoRoles, roleList: organizedUnitId === this.state.selectedUo ? uo.notOwnedRoles : this.state.roleList })
    }
  }

  submitUser (values) {
    const body = {
      ...values.user,
      uoRoles: this.state.uoList.map(uoRol => {
        return {
          organizedUnitId: uoRol.organizedUnitId,
          ownedRoles: uoRol.ownedRoles
        }
      }),
      uoSalesman: this.state.uoSalesman
        .ownedUO.map(uo => {
          return uo.uoId
        })
    }
    this.props.actions.submitUser(this.props.userId, body)
  }

  handleSavePassword () {
    this.props.actions.adminChangePassword(this.props.userId, this.state.newPassword, this.state.repeatNewPassword, this.props.emailAddress)
    this.setState({ showChangePassword: false, newPassword: null, repeatNewPassword: null })
    this.props.change('pwd.newPassword', null)
    this.props.change('pwd.pwdLoginRepeat', null)
  }

  uploadSign () {
    this.props.actions.openUploadSignModal()
  }

  downloadSign () {
    this.props.actions.downloadSignUser(this.props.userId)
  }

  validatePassword (newPassword) {
    if (newPassword && newPassword.length < this.props.passwordPolicy.minNumberOfCharactersInPassword) {
      return false
    }
    return true
  }

  render () {
    const {
      t, handleSubmit,
      showModal, /* uoRoles, */ userId,
      combos: { languagesCombo, UOTreeCombo }
    } = this.props

    const deleteTooltip = (<Tooltip id="deleteTooltip">{t('ADMIN.USERS.DELETE_BTN')}</Tooltip>)
    const saveTooltip = (<Tooltip id="saveTooltip">{t('ADMIN.USERS.SAVE_BTN')}</Tooltip>)
    const cancelTooltip = (<Tooltip id="cancelTooltip">{t('ADMIN.USERS.CANCEL_BTN')}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t('ADMIN.RECOVER')}</Tooltip>)

    return (
      <Modal id="userAdminModal" className="_nf" show={showModal} onHide={this.props.actions.closeEditUserModal}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitUser.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.closeEditUserModal}>
            <Modal.Title>{t('USER_MANAGEMENT.MODAL.TITLE')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="user.name"
                controlLabel={t('ADMIN.USERS.NAME')}
                placeholder={t('ADMIN.USERS.NAME')}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="user.surnames"
                controlLabel={t('ADMIN.USERS.SURNAME')}
                placeholder={t('ADMIN.USERS.SURNAME')}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="user.emailAddress"
                controlLabel={t('ADMIN.USERS.EMAIL')}
                placeholder={t('ADMIN.USERS.EMAIL')}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="languageId"
                name="user.languageId"
                controlLabel={t('ADMIN.USERS.LANGUAJE')}
                placeholder={t('ADMIN.USERS.LANGUAJE')}
                options={languagesCombo}
                valueKey="languageId"
                labelKey="description"
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="user.department"
                controlLabel={t('ADMIN.USERS.DEPARTAMENT')}
                placeholder={t('ADMIN.USERS.DEPARTAMENT')}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="user.position"
                controlLabel={t('ADMIN.USERS.POSITION')}
                placeholder={t('ADMIN.USERS.POSITION')}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="user.code"
                controlLabel={t('ADMIN.USERS.CODE')}
                placeholder={t('ADMIN.USERS.CODE')}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="user.phone"
                controlLabel={t('ADMIN.USERS.PHONE')}
                placeholder={t('ADMIN.USERS.PHONE')}
              />
              <Field
                component={InputTreeSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="user.organizedUnit"
                controlLabel={t('ADMIN.USERS.SHOW_UO')}
                placeholder={t('ADMIN.USERS.SHOW_UO')}

                multi={true}
                valueKey="value"
                labelKey="label"
                childrenKey="children"
                options={UOTreeCombo}
              />
              {userId === null &&
                <Field
                  component={InputCheckBox}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  name="user.sendEmailFlag"
                  placeholder={t('ADMIN.USERS.SEND_PASS')}
                />
              }
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="user.maxMobileInstalls"
                controlLabel={t('ADMIN.MAX_INSTALLATION')}
                placeholder={t('ADMIN.MAX_INSTALLATION')}
              />
            </div>
            <br/>
            <div className='flexInLine al-L'>
              {this.state.isOldUser &&
                <Button className="_Btn new" onClick={() => this.uploadSign()}><i className='iDocIcon-add-plus' /> {t('ADMIN.USERS.UPLOAD_SIGN.UPLOAD_SIGN_USER')}</Button>
              }
              {this.state.isOldUser &&
                <Button className="_Btn accept" onClick={() => this.downloadSign()}><i className='iDocIcon-download'/> {t('ADMIN.USERS.UPLOAD_SIGN.DOWNLOAD_SIGN_USER')}</Button>
              }
              {this.state.isOldUser &&
                <>
                  {!this.state.showChangePassword &&
                    <Button className="_Btn accept stk" onClick={() => this.setState({ showChangePassword: !this.state.showChangePassword })}>{t('ADMIN.USERS.CHANGE_PASSWORD')}</Button>
                  }

                </>
              }
            </div>
            {this.state.isOldUser &&
              <>
                {this.state.showChangePassword &&
                  <div className="flexInLineContainer">
                    <div className="flexInL">
                      <Field
                        component={InputPassword}
                        colWidth={50} // 25, 33, 50, 75, 100 default=25
                        t={t}
                        id='newPassword'
                        name='pwd.newPassword'
                        placeholder={t('PROFILE.NEW_PASSWORD')}
                        controlLabel={t('PROFILE.NEW_PASSWORD')}
                        onInputChange={(val) => this.setState({ newPassword: val.target.value })}
                      />
                      <Field
                        component={InputPassword}
                        colWidth={50} // 25, 33, 50, 75, 100 default=25
                        t={t}
                        id='pwdLoginRepeat'
                        name='pwd.pwdLoginRepeat'
                        placeholder={t('PROFILE.REPEAT_PASSWORD')}
                        controlLabel={t('PROFILE.REPEAT_PASSWORD')}
                        onChange={(val) => this.setState({ repeatNewPassword: val.target.value })}
                      />
                    </div>
                    <div className="flexInR">
                      { this.state.newPassword && this.state.repeatNewPassword && this.state.repeatNewPassword !== '' && this.state.newPassword !== '' && this.validatePassword(this.state.newPassword) &&
                        <Button className="_Btn new" onClick={() => this.handleSavePassword()}>{t('ADMIN.USERS.SAVE_PASSWORD')}</Button>
                      }
                      <Button className="_Btn cancel" onClick={() => this.setState({ showChangePassword: !this.state.showChangePassword })}>{t('ADMIN.USERS.CANCEL_BTN')}</Button>
                    </div>
                  </div>
                }
              </>
            }

            <div className='groupRol-Uo'>

              <div className='colWidth-50'>
                <div className="section-header-title">
                  <h4>{t('USER_MANAGEMENT.MODAL.ASSIGNED_ROLES')}</h4>
                  {!this.state.editing ? (
                    <Button
                      className="_Btn new"
                      onClick={() => this.setState({ editing: true })}
                    >
                      <i className='iDocIcon-add-plus'></i>{t('MASTERS.ADD')}
                    </Button>
                  ) : <></>
                  }
                </div>
                <div className='section-body-container'>
                  {this.state.editing === true &&
                    <div className="flexInLineContainer">
                      <div className="flexInL">
                        <Field
                          component={InputSelect}
                          colWidth={50} // 25, 33, 50, 75, 100 default=25
                          name="userRol.organizedUnit"
                          placeholder={t('ADMIN.USERS.UO')}
                          valueKey="organizedUnitId"
                          labelKey="name"
                          options={this.state.uoList}
                          onInputChange={(value) => this.setActiveUoRol(value)}
                        />
                        <Field
                          component={InputSelect}
                          colWidth={50} // 25, 33, 50, 75, 100 default=25
                          name="userRol.role"
                          placeholder={t('ADMIN.USERS.ROL')}
                          options={this.state.roleList}
                          valueKey="roleId"
                          labelKey="description"
                          disabled={!this.state.roleList || this.state.roleList.length === 0}
                          onInputChange={(value) => this.setState({ selectedRole: value })}
                        />
                      </div>
                      <div className="flexInR">
                        {this.state.selectedRole &&
                          <OverlayTrigger placement="left" overlay={saveTooltip}>
                            <a className='_Btn new o-icn' onClick={() => this.addPermission(this.state.selectedRole)} id="ico-check"><i className="iDocIcon-done-ok"/></a>
                          </OverlayTrigger>
                        }
                        <OverlayTrigger placement="left" overlay={cancelTooltip}>
                          <a className='_Btn cancel o-icn' onClick={() => this.setState({ editing: false })} id="ico-cancel"><i className="iDocIcon-clear-decline"/></a>
                        </OverlayTrigger>
                      </div>
                    </div>
                  }

                  <ul className="role-tree permissionsList" id="role-modal-tree-list">
                    {this.state.uoList && this.state.uoList.length > 0 && this.state.uoList.filter(uoRol => uoRol.ownedRoles.length > 0).map(uo => {
                      return (
                        <li key={uo.organizedUnitId}>
                          <p className='permissionLabel'>{uo.name}</p>
                          {uo.ownedRoles.length > 0 && (
                            <ul>
                              {uo.ownedRoles.map(rol => {
                                return <li key={rol.roleId}>
                                  <span>{rol.description}</span>
                                  <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                    <a className='_Btn cancel stk o-icn slimBtn' onClick={() => this.deletePermission(rol.roleId, uo.organizedUnitId)}>
                                      <i className="iDocIcon-delete-forever"/>
                                    </a>
                                  </OverlayTrigger>
                                </li>
                              })}
                            </ul>
                          )}
                        </li>
                      )
                    })}
                  </ul>

                </div>
              </div>
              {this.state.sectionTabsConfiguration && (this.state.sectionTabsConfiguration.salesmanUo === undefined || (this.state.sectionTabsConfiguration.salesmanUo.permission > permissions.hidden)) && (
                <div className='colWidth-50'>
                  <div className="section-header-title">
                    <h4>{t('USER_MANAGEMENT.MODAL.ASSIGNED_UO')}</h4>
                    {!this.state.editingUO ? (
                      <Button
                        className="_Btn new"
                        onClick={() => this.setState({ editingUO: true })}
                      >
                        <i className='iDocIcon-add-plus'></i>{t('MASTERS.ADD')}
                      </Button>
                    ) : <></>
                    }
                  </div>
                  <div className='section-body-container'>
                    {this.state.editingUO &&
                      <div className="flexInLineContainer">
                        <div className="flexInL">
                          <Field
                            component={InputSelect}
                            colWidth={100} // 25, 33, 50, 75, 100 default=25
                            name="userUO.organizedUnit"
                            placeholder={t('ADMIN.USERS.UO')}
                            valueKey="uoId"
                            labelKey="name"
                            popupContainer=".role-modal"
                            options={this.state.uoSalesman.notOwnedUO}
                            colSm={12}
                            onInputChange={(value) => this.setActiveUo(value)}
                          />
                        </div>
                        <div className="flexInR">
                          {this.state.selectedUo &&
                            <OverlayTrigger placement="left" overlay={saveTooltip}>
                              <a className='_Btn new o-icn' onClick={() => this.addUO(this.state.selectedUo)}><i className="iDocIcon-done-ok"/></a>
                            </OverlayTrigger>
                          }
                          <OverlayTrigger placement="left" overlay={cancelTooltip}>
                            <a className='_Btn cancel o-icn' onClick={() => this.setState({ editingUO: false })}><i className="iDocIcon-clear-decline"/></a>
                          </OverlayTrigger>
                        </div>
                      </div>
                    }
                    <ul className="role-tree permissionsList" id="role-modal-tree-list">
                      {this.state.uoSalesman && this.state.uoSalesman.ownedUO && this.state.uoSalesman.ownedUO.map((uo, idx) => {
                        return (
                          <li key={idx}>
                            <span className=''>{uo.name}</span>
                            { uo.notDelete === false &&
                                <OverlayTrigger placement="left" overlay={deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn slimBtn' onClick={() => this.deleteUO(uo.uoId)}>
                                    <i onClick={() => this.setState({ lastAdd: false })} className="iDocIcon-delete-forever"/>
                                  </a>
                                </OverlayTrigger>
                            }
                            {uo.notDelete !== false &&
                                <OverlayTrigger placement="left" overlay={uo.isDeleteSalesman ? recoverTooltip : deleteTooltip}>
                                  <a className='_Btn cancel stk o-icn slimBtn' onClick={() => this.deleteRecoverSalesman(uo)}>
                                    { uo.isDeleteSalesman ? (<Glyphicon glyph="repeat"/>) : (<i className="iDocIcon-delete-forever"/>) }
                                  </a>
                                </OverlayTrigger>
                            }
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}
              >
                {t('ROLE_MANAGEMENT.NEW_ROL_MODAL.SUBMIT_BUTTON')}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
        <UploadSignPage />
      </Modal>
    )
  }
}

const validate = (values, props) => {
  const error = { user: {}, pwd: {} }
  if (values.user) {
    if (!values.user.name) {
      error.user.name = props.t('ADMIN.USERS.VALIDATION.NAME_REQUIRED')
    }
    if (!values.user.surnames) {
      error.user.surnames = props.t('ADMIN.USERS.VALIDATION.SURNAME_REQUIRED')
    }
    if (!values.user.emailAddress) {
      error.user.emailAddress = props.t('ADMIN.USERS.VALIDATION.EMAIL_REQUIRED')
    }
    if (!values.user.languageId) {
      error.user.languageId = props.t('ADMIN.USERS.VALIDATION.LANGUAJE_REQUIRED')
    }
    if (!isEmail(values.user.emailAddress)) {
      error.user.emailAddress = props.t('ADMIN.USERS.VALIDATION.VALID_EMAIL')
    }
    if (!isValidPhone(values.user.phone)) {
      error.user.phone = props.t('ADMIN.USERS.VALIDATION.VALID_PHONE')
    }
  } else {
    error.user.name = props.t('ADMIN.USERS.VALIDATION.NAME_REQUIRED')
    error.user.surnames = props.t('ADMIN.USERS.VALIDATION.SURNAME_REQUIRED')
    error.user.emailAddress = props.t('ADMIN.USERS.VALIDATION.EMAIL_REQUIRED')
    error.user.languageId = props.t('ADMIN.USERS.VALIDATION.LANGUAJE_REQUIRED')
  }
  if (values.pwd && values.pwd.newPassword && values.pwd.newPassword.length < props.passwordPolicy.minNumberOfCharactersInPassword) {
    error.pwd.newPassword = props.t('RESET_PASSWORD.MUST_CONTAIN_X_CHARACTERS').replace('##NUMBER##', props.passwordPolicy.minNumberOfCharactersInPassword)
  }

  return Object.keys(error.user).length > 0 || Object.keys(error.pwd).length > 0 ? error : {}
}

export default reduxForm({
  form: 'editUser',
  validate
})(UserModal)
